import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ShopcategoryView = () => {
  const [ShopcategoryUser, setShopcategoryUser] = useState({
    cat_image: "",
    heading: "",
    cat_stock: "",
    cat_status: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const ShopcategoryData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_Shopcategory_by_id",
          {
            cat_id: id
          }
        );
        setShopcategoryUser(response.data.result);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    ShopcategoryData();
  }, [id]);

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories View</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card Shopcategory-view">
            <div className="cross-icon">
              <Link to="/ShopByCategory">
              <i className="fa-solid fa-circle-xmark"></i>
              </Link>
            </div>
              <div>
                <img
                  src={`https://cyberathon.com/multivendor/${ShopcategoryUser.cat_image}`}
                  width={600} height={400}
                />
              </div>
              <strong>Shopcategory Name</strong>
              <p>{ShopcategoryUser.heading}</p>
              <strong>Created By</strong>
              <p>{ShopcategoryUser.cat_created_by}</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default ShopcategoryView;
